import { apiSlice } from './apiSlice';
import { PURCHASES_URL } from '../constants';

export const purchasesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new purchase
    createPurchase: builder.mutation({
      query: (purchase) => ({
        url: PURCHASES_URL,
        method: 'POST',
        body: purchase,
      }),
    }),
    // Get purchase details by ID
    getPurchaseDetails: builder.query({
      query: (id) => ({
        url: `${PURCHASES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get logged-in user's purchases
    getMyPurchases: builder.query({
      query: () => ({
        url: `${PURCHASES_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get all purchases (Admin view)
    getPurchases: builder.query({
      query: () => ({
        url: PURCHASES_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    // Mark a purchase as delivered (Admin action)
    deliverPurchase: builder.mutation({
      query: (purchaseId) => ({
        url: `${PURCHASES_URL}/${purchaseId}/deliver`,
        method: 'PUT',
      }),
    }),
    // Delete a purchase (Admin action)
    deletePurchase: builder.mutation({
      query: (purchaseId) => ({
        url: `${PURCHASES_URL}/${purchaseId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useCreatePurchaseMutation,
  useGetPurchaseDetailsQuery,
  useGetMyPurchasesQuery,
  useGetPurchasesQuery,
  useDeliverPurchaseMutation,
  useDeletePurchaseMutation,
} = purchasesApiSlice;